export { default } from './PlaceholderImage';
